/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionListItemDto } from './QuestionListItemDto';
import {
    QuestionListItemDtoFromJSON,
    QuestionListItemDtoFromJSONTyped,
    QuestionListItemDtoToJSON,
    QuestionListItemDtoToJSONTyped,
} from './QuestionListItemDto';

/**
 * 
 * @export
 * @interface QuestionListResponse
 */
export interface QuestionListResponse {
    /**
     * Questionnaire ID
     * @type {string}
     * @memberof QuestionListResponse
     */
    questionnaireId?: string;
    /**
     * Questionnaire name
     * @type {string}
     * @memberof QuestionListResponse
     */
    questionnaireName?: string;
    /**
     * List of questions
     * @type {Array<QuestionListItemDto>}
     * @memberof QuestionListResponse
     */
    questions?: Array<QuestionListItemDto>;
    /**
     * Total number of questions
     * @type {number}
     * @memberof QuestionListResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the QuestionListResponse interface.
 */
export function instanceOfQuestionListResponse(value: object): value is QuestionListResponse {
    return true;
}

export function QuestionListResponseFromJSON(json: any): QuestionListResponse {
    return QuestionListResponseFromJSONTyped(json, false);
}

export function QuestionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'questionnaireId': json['questionnaireId'] == null ? undefined : json['questionnaireId'],
        'questionnaireName': json['questionnaireName'] == null ? undefined : json['questionnaireName'],
        'questions': json['questions'] == null ? undefined : ((json['questions'] as Array<any>).map(QuestionListItemDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function QuestionListResponseToJSON(json: any): QuestionListResponse {
    return QuestionListResponseToJSONTyped(json, false);
}

export function QuestionListResponseToJSONTyped(value?: QuestionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionnaireId': value['questionnaireId'],
        'questionnaireName': value['questionnaireName'],
        'questions': value['questions'] == null ? undefined : ((value['questions'] as Array<any>).map(QuestionListItemDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

